export const malformedDataMessage =
  'This booking cannot be processed due to incorrect data loading. Please reject it and ask the customer to make a new one.';
